import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Toaster } from "@jti/ui/components/Toaster";
import { ReactQueryClientProvider } from "../../providers/ReactQueryClientProvider";
import { StandardProductDetails } from "./components";
export const StandardProductDetailsContainer = (props) => (_jsxs(ReactQueryClientProvider, { children: [_jsx(StandardProductDetails, { ...props }), _jsx(Toaster, {})] }));
//# sourceMappingURL=StandardProductDetailsContainer.js.map